import { EscalatorChapter, MediaInfo } from './type';

export const CUBBY_SLOT_COUNT = 6;

export const PRESET_PREVIEW_VIDEOS: Record<number, string> = {
  1: 'https://res.cloudinary.com/jbboerner/video/upload/v1781104672/nikehyperlive-uat/1781104672528.mp4',
  2: 'https://res.cloudinary.com/jbboerner/video/upload/v1781104691/nikehyperlive-uat/1781104689646.mp4',
};

export function getPresetPreviewVideo(preset = 1): string {
  return PRESET_PREVIEW_VIDEOS[preset] ?? PRESET_PREVIEW_VIDEOS[1];
}

export function getMsSinceMidnight(now = Date.now()): number {
  const date = new Date(now);
  return (
    date.getHours() * 3_600_000 +
    date.getMinutes() * 60_000 +
    date.getSeconds() * 1_000 +
    date.getMilliseconds()
  );
}

export function getTotalCycleDuration(chapters: EscalatorChapter[]): number {
  return chapters.reduce((sum, chapter) => sum + (chapter.duration ?? 0), 0);
}

export interface ActiveChapterState {
  chapterIndex: number;
  chapter: EscalatorChapter;
  elapsedInChapterMs: number;
}

export function getActiveChapterFromSchedule(
  chapters: EscalatorChapter[],
  msSinceMidnight: number,
): ActiveChapterState | null {
  if (!chapters.length) {
    return null;
  }

  const totalDuration = getTotalCycleDuration(chapters);
  if (totalDuration <= 0) {
    return null;
  }

  const positionInCycle = msSinceMidnight % totalDuration;
  let offset = 0;

  for (let index = 0; index < chapters.length; index += 1) {
    const duration = chapters[index].duration ?? 0;
    if (positionInCycle < offset + duration) {
      return {
        chapterIndex: index,
        chapter: chapters[index],
        elapsedInChapterMs: positionInCycle - offset,
      };
    }
    offset += duration;
  }

  const lastIndex = chapters.length - 1;
  return {
    chapterIndex: lastIndex,
    chapter: chapters[lastIndex],
    elapsedInChapterMs: 0,
  };
}

export function getMsUntilNextChapterBoundary(
  chapters: EscalatorChapter[],
  msSinceMidnight: number,
): number {
  const active = getActiveChapterFromSchedule(chapters, msSinceMidnight);
  if (!active) {
    return 1_000;
  }

  const remaining = (active.chapter.duration ?? 0) - active.elapsedInChapterMs;
  return Math.max(remaining, 250);
}

export function formatDurationMs(ms: number): string {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1_000));
  const hours = Math.floor(totalSeconds / 3_600);
  const minutes = Math.floor((totalSeconds % 3_600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

export function getNextChapterIndex(chapters: EscalatorChapter[], currentIndex: number): number {
  if (!chapters.length) {
    return 0;
  }
  return (currentIndex + 1) % chapters.length;
}

export function getCubbyAssets(assets: MediaInfo[] = []): MediaInfo[] {
  return assets
    .slice(0, CUBBY_SLOT_COUNT)
    .filter(asset => Boolean(asset?.url));
}
